import { render, staticRenderFns } from "./DiscountPolicyAppend.vue?vue&type=template&id=01f2c37f&scoped=true"
import script from "./DiscountPolicyAppend.vue?vue&type=script&lang=js"
export * from "./DiscountPolicyAppend.vue?vue&type=script&lang=js"
import style0 from "./DiscountPolicyAppend.vue?vue&type=style&index=0&id=01f2c37f&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f2c37f",
  null
  
)

export default component.exports